<div class="pad-bottom-20">
  <h4>
    @if (!!claimGeneralData?.vehicle) {
      <span
        ><span
          >{{ claimGeneralData?.vehicle?.vin ? vehicleDesctiption : vehicleNotOnPolicy
          }}<br /> </span
      ></span>
    }
    @if (!!(claimProgressData && claimProgressData.lossDescription)) {
      <span>-</span>
    }
    @if (!!claimProgressData) {
      <span>{{ claimProgressData?.lossDescription }}</span>
    }
    @if (!!claimProgressData.lossDetailDescription) {
      <span>,</span>
    }
    @if (!!claimProgressData.lossDetailDescription) {
      <span>{{ claimProgressData?.lossDetailDescription }}</span>
    }
  </h4>
</div>

@if (displayContinueClaim) {
  <ds-claim-post-fnol-cta (continue)="routeToPostFnolFlow()"></ds-claim-post-fnol-cta>
}

<div class="row pad-bottom-20">
  <ds-claim-progress-tracker
    [progressData]="claimProgressData"
    [claimType]="claimDetailConstant.AUTO"
  >
  </ds-claim-progress-tracker>
</div>
@if (claim.claimProgress.toUpperCase() !== 'CLOSED') {
  <div class="row">
    <div class="row pad-bottom-20 pad-top-20">
      <div
        class="heading-sub-page bottom-grey-border pad-bottom-20 pad-top-20"
        dsContent
        [contentPath]="'claims.claimActivityText'"
        data-cy="claimStatusActivityText"
      ></div>
      <ds-claim-activity [activityData]="claimActivityData"></ds-claim-activity>
    </div>
    <div class="row pad-top-20">
      <span
        class="heading-sub-page"
        dsContent
        [contentPath]="'claims.claimDetailsText'"
        data-cy="claimStatusDetailsText"
      >
      </span>
    </div>
    <div class="row">
      <ds-accordion [allowMultipleOpenCategories]="true" [allowToggleAccordion]="true">
        <ds-accordion-category [title]="summary" data-cy="claimSummary">
          <ds-claim-status-general
            [claimGeneralData]="claimGeneralData"
            [hasGeneralData]="hasGeneralData"
            [claimType]="claimDetailConstant.AUTO"
          ></ds-claim-status-general>
        </ds-accordion-category>
        @if (photosEnabled) {
          <ds-accordion-category [title]="photos">
            <ds-claim-photo-summary
              [claimNumber]="claimNumber"
              [photoList]="photoList"
              [viewPhotosAuthorized]="viewPhotosAuthorized"
              [uploadPhotosAuthorized]="uploadPhotosAuthorized"
              (uploadPhotos)="routeToPhotoUpload()"
            ></ds-claim-photo-summary>
          </ds-accordion-category>
        }
        @if (
          (rentalCarData && rentalCarData.serviceRequestData) ||
          (!eligibleServicesError &&
            ((!postFnolEnabled && claimServicesStatus.rentalCoverage) ||
              (postFnolEnabled &&
                (!claimServicesStatus.rentalCoverage ||
                  (!claimServicesStatus.rentalEligible &&
                    !claimServicesStatus.rentalDependencyUnmet)))))
        ) {
          <ds-accordion-category [title]="rentalCar">
            <ds-claim-status-rentalcar
              [claimRentalCarData]="rentalCarData"
              [rentalCoverage]="claimServicesStatus.rentalCoverage"
              [rentalDependencyUnmet]="claimServicesStatus.rentalDependencyUnmet"
              [rentalEligible]="claimServicesStatus.rentalEligible"
              [isPartner]="isPartner"
              [rentalPhoneNumber]="rentalPhoneNumber"
            ></ds-claim-status-rentalcar>
          </ds-accordion-category>
        }
        <ds-accordion-category [title]="payments">
          <ds-claim-status-payments
            [claimPaymentsData]="buildPaymentsData(claim)"
          ></ds-claim-status-payments>
        </ds-accordion-category>
        @if (towingAndRepairData.length > 0) {
          <ds-accordion-category [title]="towingAndRepairShops">
            <!-- Move buildRepairData method to component -->
            <ds-claim-status-towing-repair-shops
              [claimTowingRepairShopData]="repairData"
              [claimNumber]="claim?.claimNumber"
            >
            </ds-claim-status-towing-repair-shops>
          </ds-accordion-category>
        }
      </ds-accordion>
    </div>
  </div>
} @else {
  <div class="row pad-bottom-20">
    <p dsContent [contentPath]="'claims.completeHeaderText1'"></p>
    <br />
    <p dsContent [contentPath]="'claims.completeHeaderText2'"></p>
  </div>
  <div class="row pad-top-20 pad-bottom-20 bottom-grey-border">
    <span
      class="heading-sub-page"
      dsContent
      [contentPath]="'claims.claimDetailsText'"
      data-cy="claimStatusDetailsText"
    >
    </span>
  </div>
  <div class="row bottom-dashed-border pad-bottom-20 pad-top-20">
    <div class="float-left"><b dsContent [contentPath]="'claims.vehicleText'"></b></div>
    <div class="float-right">
      <span
        >{{ claimGeneralData?.vehicle?.vin ? vehicleDesctiption : vehicleNotOnPolicy }}<br />
      </span>
    </div>
  </div>
  @if (claimGeneralData?.vehicle?.vin) {
    <div class="row bottom-dashed-border pad-bottom-20 pad-top-20">
      <div class="float-left"><b dsContent [contentPath]="'claims.policyText'"></b></div>
      <div class="float-right">{{ claimGeneralData.policyNumber | prettyPolicyNum }}</div>
    </div>
  }
  <div class="row bottom-dashed-border pad-bottom-20 pad-top-20">
    <div class="float-left"><b dsContent [contentPath]="'claims.statusText'"></b></div>
    @if (!!claim?.closedDate) {
      <div class="float-right">Closed on {{ claim?.closedDate | date: 'shortDate' }}</div>
    }
    @if (!claim?.closedDate) {
      <div class="float-right">Closed</div>
    }
  </div>
  <div class="row bottom-dashed-border pad-bottom-20 pad-top-20">
    <div class="float-left">
      <b dsContent [contentPath]="'claims.dateAndTimeIncidentText'"></b>
    </div>
    <div class="float-right">
      <span>{{ claimGeneralData.incidentDate }}</span> <br />
      <span>{{ claimGeneralData.timeOfIncident }}</span>
    </div>
  </div>
  @if (claimGeneralData?.claimDescription) {
    <div class="row bottom-dashed-border pad-bottom-20 pad-top-20">
      <div class="float-left">
        <b dsContent [contentPath]="'claims.incidentDescriptionText'"></b>
      </div>
      <div class="float-right">{{ claimGeneralData?.claimDescription }}</div>
    </div>
  }
  <div class="row pad-top-20 pad-bottom-20 bottom-grey-border">
    <span
      class="heading-sub-page"
      dsContent
      [contentPath]="'claims.claimContactText'"
      data-cy="claimContactText"
    >
    </span>
  </div>
  @if (claim?.primaryFileHandler) {
    <div class="row bottom-dashed-border pad-bottom-20 pad-top-20">
      <div class="float-left"><b dsContent [contentPath]="'claims.adjusterText'"></b></div>
      <div class="float-right">
        {{ claim.primaryFileHandler.firstName }} {{ claim.primaryFileHandler.lastName }}
      </div>
    </div>
  }
  <div class="row bottom-dashed-border pad-bottom-20 pad-top-20">
    <div class="float-left"><b dsContent [contentPath]="'claims.phoneText'"></b></div>
    <div class="float-right">
      {{ phoneNumber }}
    </div>
  </div>
  @if (claim?.primaryFileHandler?.emails?.length > 0) {
    <div class="row bottom-dashed-border pad-bottom-20 pad-top-20">
      <div class="float-left"><b dsContent [contentPath]="'claims.emailText'"></b></div>
      <div class="float-right">{{ claim.primaryFileHandler.emails[0].emailAddress }}</div>
    </div>
  }
}
